import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State } from '../reducers/bulk-mail.reducer';

const bulkMailFeatureKey = 'bulkMail';

const selectBulkMailState = createFeatureSelector<State>(bulkMailFeatureKey);

export const getSendBulkMailResult = createSelector(selectBulkMailState, state => state.sendBulkMailResult);
